import React, { useState } from "react";
import {
  FormControl,
  IconButton,
  Input,
  InputLabel,
  OutlinedInput,
  Tooltip,
} from "@mui/material";
import { InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface IProps {
  placeHolder: string;
  value: string;
  fieldKey?: string;
  onChange?: (e: any) => void;
  disabled?: boolean;
  isMandatory?: boolean;
}

export const HideOrShowText = ({
  placeHolder,
  value,
  fieldKey,
  onChange,
  disabled,
  isMandatory,
}: IProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClickShowText = () => {
    setIsVisible(!isVisible);
  };

  return (
    <>
      <FormControl className="custom-select" fullWidth>
        <InputLabel>
          {placeHolder}
          {isMandatory && (
            <>
              <div
                style={{
                  display: "inline-block",
                  color: "red",
                }}
              >
                *
              </div>
            </>
          )}
        </InputLabel>

        <OutlinedInput
          type={isVisible ? "text" : "password"}
          id={fieldKey + "-id"}
          label={placeHolder}
          name={fieldKey}
          value={value}
          onChange={onChange}
          disabled={disabled}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle text visibility"
                onClick={handleClickShowText}
                edge="end"
              >
                {isVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  );
};
